import React, { Component } from 'react';
import { Link } from 'react-router';

import Pagination from "../../components/Pagination";
import BandStore from "../../stores/BandStore";
import SessionStore from "../../stores/SessionStore";

class BandRow extends Component {
  render() {
    var maps = "";
    var namestr = this.props.band.name;
    var hasLink = this.props.band.userdefine;

    for (var i=0; i<this.props.band.frequencyUp.length; i++) {
      if (this.props.band.frequencyUp[i]!==0) {
        if (maps !== "")
          maps += ", ";
        maps += "" + this.props.band.frequencyUp[i];
      }
    }

    if ( ! this.props.band.admin )
      hasLink = false;
    
    return(
      <tr>
        <td>{hasLink ? <Link to={`/bands/${this.props.band.id}`}>{namestr}</Link> : namestr}</td>
        <td>{this.props.band.txpower}</td>
        <td>{this.props.band.rx2Dr}</td>
        <td>{this.props.band.rx2Frequency}</td>
        <td>{maps}</td>
        <td><span className={"glyphicon glyphicon-" + (this.props.band.userdefine ? 'ok' : 'remove')} aria-hidden="true"></span></td>
      </tr>
    )
  }
}

class ListBands extends Component {
  constructor() {
    super();
    this.state = {
      pageSize: 20,
      lists:  [],
      isAdmin: false,
      pageNumber: 1,
      pages: 1,
    };

    this.updatePage = this.updatePage.bind(this);
  }

  componentDidMount() {
    this.updatePage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updatePage(nextProps);
  }

  updatePage(props) {
    const page = (props.location.query.page === undefined) ? 1 : props.location.query.page;

    BandStore.getAll("", this.state.pageSize, (page-1) * this.state.pageSize, (totalCount, bands) => {
      this.setState({
    	  lists: bands,
        pageNumber: page,
        pages: Math.ceil(totalCount / this.state.pageSize),
      });
      window.scrollTo(0, 0);
    });
  }


  componentWillMount() {
    this.setState({
      isAdmin: SessionStore.isAdmin(),
    });

    SessionStore.on("change", () => {
      this.setState({
        isAdmin: SessionStore.isAdmin(), 
      });
    });
  }

  render () {
    const BandRows = this.state.lists.map((band, i) => <BandRow key={band.id} band={band} />);

    return(
      <div>
        <ol className="breadcrumb">
          <li className="active">Bands</li>
        </ol>
        <div className="clearfix">
          <div className="btn-group pull-right" role="group" aria-label="...">
            <Link to="/bands/create"><button type="button" className="btn btn-default">Create Band</button></Link>
          </div>
        </div>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Tx Power(dBm)</th>
                  <th>Rx2 Data Rate</th>
                  <th>Rx2 Frequency(MHz)</th>
                  <th>Channel list(MHz)</th>
                  <th>User Defined</th>
                </tr>
              </thead>
              <tbody>
                {BandRows}
              </tbody>
            </table>
          </div>
          <Pagination pages={this.state.pages} currentPage={this.state.pageNumber} pathname="/bands" />
        </div>
      </div>
    );
  }
}

export default ListBands;



// WEBPACK FOOTER //
// ./src/views/bands/ListBands.js